import { render, staticRenderFns } from "./shopEdit.vue?vue&type=template&id=22908816&scoped=true&"
import script from "./shopEdit.vue?vue&type=script&lang=js&"
export * from "./shopEdit.vue?vue&type=script&lang=js&"
import style0 from "./shopEdit.vue?vue&type=style&index=0&id=22908816&lang=less&scoped=true&"
import style1 from "./shopEdit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22908816",
  null
  
)

export default component.exports